import React from "react";

import SuccessImage from "../../../../../../../../assets/images/candidate-success.svg";

function RejectionProcessed() {
  return (
    <>
      <h5>Thank you for submitting your candidate feedback!</h5>
      <div style={{ marginTop: 16, display: "flex", flexDirection: "row" }}>
        <SuccessImage
          style={{ height: 80, width: 235, marginRight: 24 }}
          alt="success.svg"
        />
        <p>
          The candidate has been rejected and the agency recruiter has been
          notified.
        </p>
      </div>
    </>
  );
}

export default RejectionProcessed;
